import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import MetadataGroupFactory from '@/Components/MetadataGroup/MetadataGroupFactory';

export default class HistorizationGroupUIListener extends UIListener {

    constructor() {
        super();
    }

    public onBeforeRender(context: DetailViewContext) {
        super.onBeforeRender(context);

        MetadataGroupFactory.hideChangelogsAndShowMetadata(context);
    }

    public onAfterRefresh(context: DetailViewContext): void {
        if (!this.isDetailViewContext(context)) {
            return;
        }

        let toolBarElement = context.toolBar.getElementByErgName('SAVE');

        if (toolBarElement != null) {
            toolBarElement.isEnabled(false);
        }
    }
}

ComponentManager.setUIListener('HistorizationGroupUIListener', HistorizationGroupUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.HistorizationGroupListener', HistorizationGroupUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');